export default __webpack_public_path__ + "static/media/microchip.0af8098c.svg";